import mixins from 'vue-typed-mixins';

import StudyMixin, { STUDY_RESULT } from '@/user/mixins/StudyMixin';
import { TEXT_COLOR } from '@/user/mixins/StudyWorkMixin';
import StudyCalcWorkMixin from '@/user/mixins/StudyCalcWorkMixin';

import UserWindowSizeUtility from '@/classes/common/UserWindowSizeUtility';



/** 算数問題用画像幅 */
const QUESTION_IMAGE_WIDTH = 634;

/** 算数問題用画像高さ */
const QUESTION_IMAGE_HEIGHT = 355;

/** 算数問題用フォントサイズ */
const DEFAULT_CALC_TEXT_SIZE = 24;

/** 算数問題番号用フォントサイズ */
const DEFAULT_CALC_NUMBER_SIZE = 14;

/** 表示テキスト */
const CALC_CHARS = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９', '＝', '＋', '－', '×', '÷', '．', '…'];

export default mixins(StudyMixin, StudyCalcWorkMixin).extend({

  name: 'Calc1Work',

  props: {
    clearSwitch: {
      type: Boolean,
      required: true,
    },
  },

  data(): {
    displayQuestionIndex: number,
    calcTextSize: number;
  } {
    return {
      displayQuestionIndex: -1,
      calcTextSize: 0
    };
  },

  mounted(): void {
    this.initializeCanvas();
    this.$_setCalcTextSize();
    this.$_setTextStyle();
  },

  methods: {
    /**
     * 画面サイズ変更検知時のハンドリング
     */
    onChangeWindowSizeHandler(): void {
      // 呼び出し側で処理を実装
      this.setCanvasSize();
      this.$_setCalcTextSize();
      this.$_setTextStyle();
      this.$_setQuestion();
    },
    history(feed: number): void {
      const targetIndex = this.displayQuestionIndex + feed;
      if (targetIndex < 0 || this.questions.length < targetIndex + 1) return;
      this.displayQuestionIndex = targetIndex;
      this.$_setQuestion();
    },
    $_clearCanvas(): void {
      this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },
    $_setCalcTextSize(): void {
      this.calcTextSize = UserWindowSizeUtility.calculateRatio(DEFAULT_CALC_TEXT_SIZE);
    },
    $_setTextStyle(): void {
      this.canvasContext.strokeStyle = TEXT_COLOR;
      this.canvasContext.lineWidth   = UserWindowSizeUtility.penSize();
      this.canvasContext.font        = UserWindowSizeUtility.canvasFont(DEFAULT_CALC_TEXT_SIZE);
    },
    $_setCalcNumStyle(): void {
      this.canvasContext.strokeStyle = TEXT_COLOR;
      this.canvasContext.lineWidth   = UserWindowSizeUtility.penSize();
      this.canvasContext.font        = UserWindowSizeUtility.canvasFont(DEFAULT_CALC_NUMBER_SIZE);
    },
    $_setQuestion(isInputClear = false): void {
      this.$_clearCanvas(); // まず描画を消しておく

      if (this.displayQuestionIndex === -1) return; // Indexが初期値の場合はreturn

      const questionData = this.questions[this.displayQuestionIndex];
      const question     = questionData.question;
      const right        = questionData.right;

      // 問題描画用設定
      this.$_setTextStyle();

      // 画像問題
      if (question.length === 0) {
        this.incrementMediaCount(); // 読み込み画像カウント
        const url = questionData.q;
        const image = new Image();
        image.onload = () => {
          // 画像描画
          if (window.innerWidth <= window.innerHeight) this.drawImage(image, 20, 10);
          else                                         this.drawImage(image, 5, 20);
          // 問題番号の表示
          this.$_drawQuestionNo();
          // 画像読み込み完了処理（タイマースタートもここ）
          this.loadMedia(isInputClear);
        };
        image.width  = QUESTION_IMAGE_WIDTH;
        image.height = QUESTION_IMAGE_HEIGHT;
        image.src    = url.substring(1, url.length - 1);

      // 通常問題
      } else {
        // 横算
        if (question.charAt(0) === 'L') {
          this.$_drawRowCalculation(question, right);
        // 筆算（＋、－、×）
        } else if (question.charAt(0) === 'V' && question.indexOf('/') === -1) {
          this.$_drawColumnCalculationWithoutDivide(question, right);
        // 筆算（「÷」）
        } else if (question.charAt(0) === 'V' && question.indexOf('/') !== -1) {
          this.$_drawColumnDivide(question, right);
        }

        // 問題番号の表示
        this.$_drawQuestionNo();
      }
    },
    $_drawRowCalculation(question: string, right: string): void {
      // 表示内容
      let str = question.substring(1);

      // 特殊処理
      str = str.replace('□', '[]');
      const index0 = str.indexOf('/*');
      const index1 = str.indexOf('*/');
      if (index0 !== -1 && index1 !== -1) str = str.substring(0, index0) + str.substring(index1 + 2);

      // 「\n」を改行文字に直して文字列を分割
      const strs = str.split('\\n');

      // 数字判定用
      const numStr = '0123456789.#[]';

      // Y座標
      let posY = 20;

      for (let y = 0; y < strs.length; y++) {
        // 分数フラグ
        const fractionFlag = (strs[y].indexOf('#') !== -1) ? true : false;

        // 分数と分数以外のＹ座標の差
        let fractionRevisionY = 0;
        if (fractionFlag) fractionRevisionY = 15;

        let posX   = DEFAULT_CALC_TEXT_SIZE + 8;
        let tmpNum = '';
        const count = strs[y].length;
        for (let i = 0; i < count; i++) {
          const c = strs[y].charAt(i);

          // 数字の場合
          if (numStr.indexOf(c) !== -1) {
            tmpNum += c;
            // 最終文字の場合は描画
            if (i === count - 1) {
              if (tmpNum.indexOf('#') !== -1) this.$_drawRatioFraction(tmpNum, posX, posY);
              else                            this.$_drawRatioNumber(tmpNum, posX, posY + fractionRevisionY);
            }
            continue;

          // 数字でない場合
          } else {
            // それまでの数字があれば描画
            if (tmpNum.length > 0) {
              if (tmpNum.indexOf('#') !== -1) posX += this.$_drawRatioFraction(tmpNum, posX, posY) * DEFAULT_CALC_TEXT_SIZE;
              else                            posX += this.$_drawRatioNumber(tmpNum, posX, posY + fractionRevisionY) * DEFAULT_CALC_TEXT_SIZE;
              tmpNum = '';
            }

            // 文字を描画
            if (c !== ' ') {
              this.$_drawRatioChar(c, posX, posY + fractionRevisionY);
              posX += DEFAULT_CALC_TEXT_SIZE;
            }
          }
        }

        // 改行を行う
        if (fractionFlag) posY += DEFAULT_CALC_TEXT_SIZE * 5 / 2;
        else              posY += DEFAULT_CALC_TEXT_SIZE * 3 / 2;
      }
    },
    $_drawColumnCalculationWithoutDivide(question: string, right: string): void {
      // 演算子の前と後を分離
      let operation = '+';
      let pos1 = question.indexOf(operation);
      if (pos1 === -1) {
        operation = '-';
        pos1 = question.indexOf(operation);
      }
      if (pos1 === -1) {
        operation = '*';
        pos1 = question.indexOf(operation);
      }
      let pos2 = question.indexOf('=');
      if (pos2 === -1) pos2 = question.length;
      let str1 = question.substring(1, pos1);
      let str2 = question.substring(pos1 + 1, pos2);

      // 小数点桁数を取得
      const fPos1 = str1.indexOf('.');
      const fPos2 = str2.indexOf('.');
      const fLen1 = (fPos1 === -1) ? 0 : str1.length - fPos1 - 1;
      const fLen2 = (fPos2 === -1) ? 0 : str2.length - fPos2 - 1;
      const fLen =  (operation === '*') ? fLen1 + fLen2 : Math.max(fLen1, fLen2);

      // 行開始位置
      let   rowIndex = 0;
      const additionalAnsHeight = 4;
      const calcRowHeight = (rowIndex: number): number => {
        return 16 + DEFAULT_CALC_TEXT_SIZE * rowIndex;
      };

      // 列終了位置
      const rowEndX = 210;

      let x1 = rowEndX;
      let x2 = rowEndX;
      // 足し算、引き算は小数点の位置を合わせる
      if (operation === '+' || operation === '-') {
        x1 -= (fLen - fLen1) * DEFAULT_CALC_TEXT_SIZE;
        x2 -= (fLen - fLen2) * DEFAULT_CALC_TEXT_SIZE;
      }

      // 1行目
      const len1 = this.$_drawRatioRightNumber(str1, x1, calcRowHeight(rowIndex));
      rowIndex++;

      // 2行目
      let len2 = this.$_drawRatioRightNumber(str2, x2, calcRowHeight(rowIndex));

      // 演算子
      const xop = Math.min(x1 - len1 * DEFAULT_CALC_TEXT_SIZE, x2 - len2 * DEFAULT_CALC_TEXT_SIZE) - DEFAULT_CALC_TEXT_SIZE;
      this.$_drawRatioChar(operation, xop, calcRowHeight(rowIndex));
      rowIndex++;

      // 問題の直下の下線
      const lineY = calcRowHeight(2) + additionalAnsHeight;
      this.drawLine(xop - DEFAULT_CALC_TEXT_SIZE / 2, lineY, rowEndX + DEFAULT_CALC_TEXT_SIZE / 2, lineY);
    },
    $_drawColumnDivide(question: string, right: string) {
      // 演算子の前と後を分離
      const pos1 = question.indexOf('/');
      let pos2 = question.indexOf('=');
      if (pos2 === -1) pos2 = question.length;
      let src1 = question.substring(1, pos1);
      let src2 = question.substring(pos1 + 1, pos2);
      let len1 = src1.length;
      if (src1.indexOf('.') !== -1) len1--;

      // ベース位置
      let   baseW = 103 + len1 * DEFAULT_CALC_TEXT_SIZE;
      const baseH = 36;

      // 問題部分（割られる数）
      this.$_drawRatioRightNumber(src1, baseW, baseH);

      // 割り算記号
      const cx = UserWindowSizeUtility.calculateRatio(baseW - (len1 + 1) * DEFAULT_CALC_TEXT_SIZE - 5);
      const cy = UserWindowSizeUtility.calculateRatio(baseH + 14);
      const radius = UserWindowSizeUtility.calculateRatio(20);
      this.canvasContext.beginPath();
      this.canvasContext.arc(cx, cy, radius, -45 * Math.PI / 180, 45 * Math.PI / 180, false);
      this.canvasContext.stroke();

      // 問題部分（割る数）
      this.$_drawRatioRightNumber(src2, baseW - (len1 + 1) * DEFAULT_CALC_TEXT_SIZE, baseH);

      // 問題の線
      this.drawLine(baseW - len1 * DEFAULT_CALC_TEXT_SIZE - 14, baseH, baseW + 10, baseH);
    },
    $_drawRatioRightNumber(str: string, x: number, y: number): number {
      // 小数点以外の文字数を調べる
      const len = str.replace('.', '').length;
      // 左から描画
      return this.$_drawRatioNumber(str, x - DEFAULT_CALC_TEXT_SIZE * len, y);
    },
    $_drawRatioNumber(str: string, x: number, y: number): number {
      const len = str.length;
      let drawCount = 0;
      for (let i = 0; i < len; i++) {
        const c = str.charAt(i);
        this.$_drawRatioChar(c, x + DEFAULT_CALC_TEXT_SIZE * drawCount, y);
        if (c !== '.') drawCount++;
      }
      return drawCount;
    },
    $_drawRatioFraction(str: string, x: number, y: number): number {
      // 分子と分母を分ける
      const pos  = str.indexOf('#');
      const str1 = str.substring(0, pos);  // 分子部
      const str2 = str.substring(pos + 1); // 分母部

      const len1   = str1.length;
      const len2   = str2.length;
      const lenMax = Math.max(len1, len2);

      // 書き出し位置の確定
      const x1 = x + (lenMax - len1) * DEFAULT_CALC_TEXT_SIZE / 2;
      const x2 = x + (lenMax - len2) * DEFAULT_CALC_TEXT_SIZE / 2;
      const y1 = y;
      const y2 = y + DEFAULT_CALC_TEXT_SIZE + 6;

      // 数字を描画
      this.$_drawRatioNumber(str1, x1, y1);
      this.$_drawRatioNumber(str2, x2, y2);

      // 分子と分母の間の線
      this.drawLine(x + 4, y2, x + lenMax * DEFAULT_CALC_TEXT_SIZE - 4, y2);

      return lenMax;
    },
    $_drawRatioChar(c: string, x: number, y: number): void {
      x = UserWindowSizeUtility.calculateRatio(x);
      y = UserWindowSizeUtility.calculateRatio(y);
      this.$_drawChar(c, x, y);
    },
    $_drawChar(c: string, x: number, y: number): void {
      const charCode = c.charCodeAt(0);
      let index = -1;
      const isNum = '0'.charCodeAt(0) <= charCode && charCode <= '9'.charCodeAt(0);
      if      (isNum)     index = charCode - '0'.charCodeAt(0);
      else if (c === '=') index = 10;
      else if (c === '+') index = 11;
      else if (c === '-') index = 12;
      else if (c === '*') index = 13;
      else if (c === '/') index = 14;
      else if (c === '.') index = 15;
      else if (c === '$') index = 16;
      else if (c === 'x') index = 0;

      if      (index === 15) this.canvasContext.fillText(CALC_CHARS[index], x - UserWindowSizeUtility.calculateRatio(3), y + this.calcTextSize, this.calcTextSize);
      else if (index !== -1) this.canvasContext.fillText(CALC_CHARS[index], x,                                           y + this.calcTextSize, this.calcTextSize);

      // 斜線を描画
      if (c === 'x') {
        this.canvasContext.beginPath();
        this.canvasContext.moveTo(x + UserWindowSizeUtility.calculateRatio(20), y + UserWindowSizeUtility.calculateRatio(4));
        this.canvasContext.lineTo(x + UserWindowSizeUtility.calculateRatio(4),  y + UserWindowSizeUtility.calculateRatio(26));
        this.canvasContext.stroke();
        this.canvasContext.closePath();
      }

      // □を描画（'['の直後は必ず']'と想定しているので、'['で']'のぶんも描画している）
      if (c === '[') {
        this.canvasContext.strokeRect(
          x + 4,
          y + 4,
          UserWindowSizeUtility.calculateRatio(DEFAULT_CALC_TEXT_SIZE * 2 - 4),
          UserWindowSizeUtility.calculateRatio(DEFAULT_CALC_TEXT_SIZE)
        );
      }
    },
    $_drawQuestionNo(): void {
      this.$_setCalcNumStyle();
      this.drawText('(' + (this.displayQuestionIndex + 1) + ')', 4, 16);
    },
  },

  watch: {
    questionIndex: {
      handler(questionIndex: number): void {
        this.displayQuestionIndex = questionIndex;
        this.$_setQuestion();
      }
    },
    // 全消去
    clearSwitch(): void {
      this.$_setQuestion(true);
    },
  }



});
